import React, { useLayoutEffect } from 'react';
import { Spinner } from '@usealloy/component-library';

const PostLoginCloseView: React.FC = () => {
  useLayoutEffect(() => {
    window.close();
  }, []);

  return <Spinner />;
};

export default PostLoginCloseView;
